<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-estimations
         class="mb-4"
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @download-excel="onDownloadExcel"
          @filtering="onFilter"
        ></filter-estimations>
        <table-paginated-estimations-complex
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          @delete-item="onPaginatedItemDelete"
        ></table-paginated-estimations-complex>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <v-btn
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="addNewEstimation"
        v-if="!isForeman"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <accept-dialog
        :is-open-dialog="isShowDeleteDialog"
        @on-close="isShowDeleteDialog=false"
        @on-accept="onAcceptDeletion"
      >
        <div class="pt-6">
          {{acceptModalText}}
        </div>
      </accept-dialog>
    </v-layout>
  </v-container>
</template>

<script>
/* constants */
import { PER_PAGE_ORDERS } from '@/constants/listing';
/* proxy */
import EstimationComplexProxy from '@/proxies/Estimations/EstimationComplexProxy';
/* mixins */
import downloadReport from '@/mixins/reports/downloadReport';
import accountMixin from '@/mixins/accountMixin';
/* components */
import PaginationListing from '@/components/listings/PaginationListing.vue';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import TablePaginatedEstimationsComplex
  from '@/components/listings/TablePaginatedEstimationsComplex.vue';
import FilterEstimations from '@/components/listings/FilterEstimations.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
import { strReplaceAll } from '@/utils';
import updatePageContentMixin from '../../mixins/updatePageContentMixin';
import paginationMixin from '../../mixins/listing/paginationMixin';
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';

export default {
  name: 'Complex',
  mixins: [
    accountMixin,
    paginationMixin,
    defaultListingMixin,
    updatePageContentMixin,
    downloadReport,
  ],
  components: {
    PaginationListing,
    ModalLoading,
    TablePaginatedEstimationsComplex,
    FilterEstimations,
    AcceptDialog,
  },
  data() {
    return {
      reportMethodName: 'estimationsComplexListingReport',
      /* Page management */
      pageLoading: false,
      /* Create - Edit */
      currentEditableItem: {},
      /* Delete */
      isShowDeleteDialog: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        search_contact: '',
      },
    };
  },
  created() {
    this.isTableLoading = true;
  },
  computed: {
    /* edit modal */
    orderDialogActionLabel() {
      if (this.isShowOrderDialog) {
        return (this.currentEditableItem.uuid)
          ? this.lang(this.$store, 'sap/listings.global.edit.save')
          : this.lang(this.$store, 'sap/listings.global.edit.create');
      }
      return '';
    },
    /* accept modal */
    acceptModalText() {
      return strReplaceAll(this.lang(this.$store, 'sap/listings.global.delete.question'), {
        user: this.currentEditableItem.datetime,
      });
    },
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new EstimationComplexProxy()
        .setParameters(this.searchParams)
        .all()
        .then(response => {
          this.paginatedObject = response.data.data.estimations;
          this.$forceUpdate();
        })
        .catch(error => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    addNewEstimation() {
      this.isRequestingNow = true;
      new EstimationComplexProxy().create({})
        .then(response => {
          this.$router.push({
            name: 'estimations.complex.show',
            params: { estimationUuid: response.data.data.estimation.uuid },
          });
        })
        .catch(error => {
          console.warn(error);
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Ошибка',
            color: 'red darken-3',
            timeout: 6000,
          });
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onAcceptDeletion() {
      this.isRequestingNow = true;
      new EstimationComplexProxy().destroy(this.currentEditableItem.uuid)
        .catch(response => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.fetchData();
        });
    },
    onPaginatedItemDelete(item) {
      this.currentEditableItem = item;
      this.isShowDeleteDialog = true;
    },
  },
};
</script>

<style scoped>

</style>
